
import Vue from "vue";
import { masterPassCheck } from "./../../../api";

export default Vue.extend({
  props: {
    show: Boolean
  },
  data: () => {
    return {
      masterPass: "",
      error: false,
      requesting: false
    };
  },
  methods: {
    exit() {
      this.$emit("exit");
    },
    async check() {
      this.requesting = true;

      let res = await masterPassCheck(this.masterPass);
      if ((res as any).authorized) {
        // Emit the validated pass so callers that need to re-send it to a
        // server endpoint (e.g. Photo Announce remove, T2-6184) can do so.
        // Existing handlers that take no argument are unaffected.
        this.$emit("valid", this.masterPass);
        this.requesting = false;
      } else {
        this.error = true;
        this.requesting = false;
      }
      this.masterPass = "";
    }
  }
});
